/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { withMyTheme } from "../../theme/theme";
import { mobileCss } from "../../util/isMobile";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { ImageResource } from "../../resources/ImageResource";
import { SocialMediaIcons } from "./SocialMediaIcons";

// const FOOTER_COLOR = '#2C3531';
const FOOTER_COLOR = 'rgb(42, 56, 50)';

const FooterContainerStyle = withMyTheme((theme) => css`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 2rem 4rem;
  background-color: ${FOOTER_COLOR};
  color: ${theme.palette.primary.contrastText};
  
  ${mobileCss(`
    display: flex;
    flex-direction: column;
    padding: 2rem 1rem;
    gap: 1.5rem;
  `)}
`);

const LogoSectionStyle = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
  ${mobileCss(`
    order: 1;
    justify-content: center;
  `)}
`;

const LogoStyle = css`
  height: 50px;
  
  ${mobileCss(`
    height: 40px;
  `)}
`;

const SocialSectionStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  
  ${mobileCss(`
    order: 2;
  `)}
`;

const PolicySectionStyle = css`
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  
  ${mobileCss(`
    order: 3;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  `)}
`;

const ButtonStyle = withMyTheme((theme) => css`
  color: ${theme.palette.primary.contrastText};
  font-family: 'Cormorant', serif;
  text-transform: none;
  font-size: 1rem;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`);

export const Footer = () => {
  return (
    <footer css={FooterContainerStyle}>
      <div css={PolicySectionStyle}>
        <Button 
          component={Link} 
          to="/privacy-policy" 
          css={ButtonStyle}
        >
          Polityka Prywatności
        </Button>
        <Button 
          component={Link} 
          to="/agreement" 
          css={ButtonStyle}
        >
          Warunki Umowy
        </Button>
      </div>
      
      <div css={SocialSectionStyle}>
        <SocialMediaIcons negative={true} />
      </div>
      
      <div css={LogoSectionStyle}>
        <img src={ImageResource.logo} alt="Weddie Site Logo" css={LogoStyle} />
      </div>
    </footer>
  );
};
